import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Common
      app_name: 'CARLOO',
      sign_in: 'Sign In',
      sign_out: 'Sign Out',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      confirm: 'Confirm',
      loading: 'Loading...',
      no_data: 'No data found',
      apply: 'Apply',
      // Auth
      email: 'Email',
      password: 'Password',
      admin: 'Admin',
      pilot: 'Pilot',
      booking_staff: 'Booking Staff',
      select_role: 'Select your role and enter credentials',
      // Pilot Dashboard
      check_in: 'Check In',
      check_out: 'Check Out',
      checked_in: 'Checked In',
      checked_out: 'Checked Out',
      not_checked_in: 'Not Checked In',
      // Breaks
      breakfast: 'Breakfast',
      tea: 'Tea',
      lunch: 'Lunch',
      dinner: 'Dinner',
      permission: 'Permission',
      mgmt_work: 'Management Work',
      end_break: 'End Break',
      currently_on: 'Currently on',
      breaks: 'Breaks',
      todays_breaks: "Today's Breaks",
      // Vehicle
      vehicle_actions: 'Vehicle Actions',
      leave_vehicle: 'Leave Vehicle',
      back_to_office: 'Back to Office',
      move_without_vehicle: 'Move w/o Vehicle',
      scan_vehicle: 'Scan Vehicle QR',
      // Trips
      my_trips: 'My Trips',
      active: 'Active',
      completed: 'Completed',
      add_trip: 'Add Trip',
      accept_trip: 'Accept Trip',
      reject_trip: 'Reject',
      start_trip: 'Start Trip',
      pickup_reached: 'Pickup Reached',
      pickup_done: 'Pickup Done',
      drop_reached: 'Drop Reached',
      unloading_done: 'Unloading Done',
      trip_started: 'Trip Started',
      km_reading: 'KM Reading',
      pickup_location: 'Pickup Location',
      drop_location: 'Drop Location',
      // Fuel
      fuel_records: 'Fuel Records',
      add_fuel: 'Add Fuel',
      fuel_amount: 'Fuel Amount (Liters)',
      fuel_cost: 'Cost',
      km_meter: 'KM Meter',
      pump_reading: 'Pump Reading',
      bill: 'Bill',
      save_fuel: 'Save Fuel Entry',
      // Status
      allocated: 'Allocated',
      accepted: 'Accepted',
      in_progress: 'In Progress',
      pending: 'Pending',
      // Camera
      take_photo: 'Take Photo',
      capture: 'Capture',
      retake: 'Retake',
      use_photo: 'Use Photo',
      gps_location: 'GPS Location',
      // Notifications
      notifications: 'Notifications',
      // Confirmations & Reverse
      are_you_sure: 'Are you sure?',
      yes: 'Yes',
      no: 'No',
      undo: 'Undo',
      undo_last: 'Undo Last Step',
      // Delay reasons
      delay_reason: 'Reason for delay',
      material_not_ready: 'Material Not Ready',
      dc_delay: 'DC Not Ready',
      loading_delay: 'Loading Delay',
      reached_early: 'Reached Early',
      others: 'Others',
      route: 'Route',
    }
  },
  ta: {
    translation: {
      app_name: 'CARLOO',
      sign_in: 'உள்நுழை',
      sign_out: 'வெளியேறு',
      cancel: 'ரத்து',
      save: 'சேமி',
      delete: 'நீக்கு',
      edit: 'திருத்து',
      create: 'உருவாக்கு',
      confirm: 'உறுதிப்படுத்து',
      loading: 'ஏற்றுகிறது...',
      no_data: 'தரவு இல்லை',
      apply: 'பயன்படுத்து',
      email: 'மின்னஞ்சல்',
      password: 'கடவுச்சொல்',
      admin: 'நிர்வாகி',
      pilot: 'ஓட்டுநர்',
      booking_staff: 'பதிவு பணியாளர்',
      select_role: 'உங்கள் பாத்திரத்தை தேர்வு செய்யவும்',
      check_in: 'வருகை பதிவு',
      check_out: 'வெளியேற்ற பதிவு',
      checked_in: 'வருகை பதிவு செய்யப்பட்டது',
      checked_out: 'வெளியேற்றம் செய்யப்பட்டது',
      not_checked_in: 'வருகை பதிவு செய்யப்படவில்லை',
      breakfast: 'காலை உணவு',
      tea: 'டீ',
      lunch: 'மதிய உணவு',
      dinner: 'இரவு உணவு',
      permission: 'அனுமதி',
      mgmt_work: 'நிர்வாக பணி',
      end_break: 'இடைவேளை முடிவு',
      currently_on: 'தற்போது',
      breaks: 'இடைவேளைகள்',
      todays_breaks: 'இன்றைய இடைவேளைகள்',
      vehicle_actions: 'வாகன நடவடிக்கைகள்',
      leave_vehicle: 'வாகனத்தை விடு',
      back_to_office: 'அலுவலகம் திரும்பு',
      move_without_vehicle: 'வாகனம் இல்லாமல் செல்',
      scan_vehicle: 'வாகன QR ஸ்கேன்',
      my_trips: 'எனது பயணங்கள்',
      active: 'செயலில்',
      completed: 'முடிந்தது',
      add_trip: 'பயணம் சேர்',
      accept_trip: 'பயணத்தை ஏற்கவும்',
      reject_trip: 'நிராகரி',
      start_trip: 'பயணம் தொடங்கு',
      pickup_reached: 'ஏற்றுமிடம் சேர்ந்தது',
      pickup_done: 'ஏற்றம் முடிந்தது',
      drop_reached: 'இறக்குமிடம் சேர்ந்தது',
      unloading_done: 'இறக்கம் முடிந்தது',
      trip_started: 'பயணம் தொடங்கியது',
      km_reading: 'KM அளவு',
      pickup_location: 'ஏற்றுமிடம்',
      drop_location: 'இறக்குமிடம்',
      fuel_records: 'எரிபொருள் பதிவுகள்',
      add_fuel: 'எரிபொருள் சேர்',
      fuel_amount: 'எரிபொருள் அளவு (லிட்டர்)',
      fuel_cost: 'செலவு',
      km_meter: 'KM மீட்டர்',
      pump_reading: 'பம்ப் அளவு',
      bill: 'பில்',
      save_fuel: 'எரிபொருள் சேமி',
      allocated: 'ஒதுக்கப்பட்டது',
      accepted: 'ஏற்கப்பட்டது',
      in_progress: 'நடப்பில்',
      pending: 'நிலுவையில்',
      take_photo: 'புகைப்படம் எடு',
      capture: 'படம்பிடி',
      retake: 'மீண்டும் எடு',
      use_photo: 'புகைப்படம் பயன்படுத்து',
      gps_location: 'GPS இருப்பிடம்',
      notifications: 'அறிவிப்புகள்',
      are_you_sure: 'உறுதியாக உள்ளீர்களா?',
      yes: 'ஆம்',
      no: 'இல்லை',
      undo: 'திரும்பப் பெறு',
      undo_last: 'முந்தைய நிலைக்கு',
      delay_reason: 'தாமதத்திற்கான காரணம்',
      material_not_ready: 'பொருள் தயாராக இல்லை',
      dc_delay: 'DC தயாராக இல்லை',
      loading_delay: 'ஏற்றுதல் தாமதம்',
      reached_early: 'சீக்கிரம் வந்தேன்',
      others: 'மற்றவை',
      route: 'வழி',
    }
  },
  hi: {
    translation: {
      app_name: 'CARLOO',
      sign_in: 'साइन इन',
      sign_out: 'साइन आउट',
      cancel: 'रद्द करें',
      save: 'सहेजें',
      delete: 'हटाएं',
      edit: 'संपादित करें',
      create: 'बनाएं',
      confirm: 'पुष्टि करें',
      loading: 'लोड हो रहा है...',
      no_data: 'कोई डेटा नहीं',
      apply: 'लागू करें',
      email: 'ईमेल',
      password: 'पासवर्ड',
      admin: 'व्यवस्थापक',
      pilot: 'चालक',
      booking_staff: 'बुकिंग स्टाफ',
      select_role: 'अपनी भूमिका चुनें',
      check_in: 'चेक इन',
      check_out: 'चेक आउट',
      checked_in: 'चेक इन हो गया',
      checked_out: 'चेक आउट हो गया',
      not_checked_in: 'चेक इन नहीं',
      breakfast: 'नाश्ता',
      tea: 'चाय',
      lunch: 'दोपहर का भोजन',
      dinner: 'रात का खाना',
      permission: 'अनुमति',
      mgmt_work: 'प्रबंधन कार्य',
      end_break: 'ब्रेक समाप्त',
      currently_on: 'वर्तमान में',
      breaks: 'ब्रेक',
      todays_breaks: 'आज के ब्रेक',
      vehicle_actions: 'वाहन क्रियाएं',
      leave_vehicle: 'वाहन छोड़ें',
      back_to_office: 'कार्यालय वापसी',
      move_without_vehicle: 'बिना वाहन चलें',
      scan_vehicle: 'वाहन QR स्कैन',
      my_trips: 'मेरी यात्राएं',
      active: 'सक्रिय',
      completed: 'पूर्ण',
      add_trip: 'यात्रा जोड़ें',
      accept_trip: 'यात्रा स्वीकार करें',
      reject_trip: 'अस्वीकार',
      start_trip: 'यात्रा शुरू',
      pickup_reached: 'पिकअप पहुंचा',
      pickup_done: 'पिकअप पूर्ण',
      drop_reached: 'ड्रॉप पहुंचा',
      unloading_done: 'उतराई पूर्ण',
      trip_started: 'यात्रा शुरू हुई',
      km_reading: 'KM रीडिंग',
      pickup_location: 'पिकअप स्थान',
      drop_location: 'ड्रॉप स्थान',
      fuel_records: 'ईंधन रिकॉर्ड',
      add_fuel: 'ईंधन जोड़ें',
      fuel_amount: 'ईंधन मात्रा (लीटर)',
      fuel_cost: 'लागत',
      km_meter: 'KM मीटर',
      pump_reading: 'पंप रीडिंग',
      bill: 'बिल',
      save_fuel: 'ईंधन सहेजें',
      allocated: 'आवंटित',
      accepted: 'स्वीकृत',
      in_progress: 'प्रगति में',
      pending: 'लंबित',
      take_photo: 'फोटो लें',
      capture: 'कैप्चर',
      retake: 'दोबारा लें',
      use_photo: 'फोटो उपयोग करें',
      gps_location: 'GPS स्थान',
      notifications: 'सूचनाएं',
    }
  },
  ml: {
    translation: {
      app_name: 'CARLOO',
      sign_in: 'സൈൻ ഇൻ',
      sign_out: 'സൈൻ ഔട്ട്',
      cancel: 'റദ്ദാക്കുക',
      save: 'സേവ് ചെയ്യുക',
      delete: 'ഡിലീറ്റ്',
      edit: 'എഡിറ്റ്',
      create: 'സൃഷ്ടിക്കുക',
      confirm: 'സ്ഥിരീകരിക്കുക',
      loading: 'ലോഡ് ചെയ്യുന്നു...',
      no_data: 'ഡാറ്റ ഇല്ല',
      apply: 'പ്രയോഗിക്കുക',
      email: 'ഇമെയിൽ',
      password: 'പാസ്‌വേഡ്',
      admin: 'അഡ്മിൻ',
      pilot: 'ഡ്രൈവർ',
      booking_staff: 'ബുക്കിംഗ് സ്റ്റാഫ്',
      select_role: 'നിങ്ങളുടെ റോൾ തിരഞ്ഞെടുക്കുക',
      check_in: 'ചെക്ക് ഇൻ',
      check_out: 'ചെക്ക് ഔട്ട്',
      checked_in: 'ചെക്ക് ഇൻ ചെയ്തു',
      checked_out: 'ചെക്ക് ഔട്ട് ചെയ്തു',
      not_checked_in: 'ചെക്ക് ഇൻ ചെയ്തിട്ടില്ല',
      breakfast: 'പ്രഭാതഭക്ഷണം',
      tea: 'ചായ',
      lunch: 'ഉച്ചഭക്ഷണം',
      dinner: 'അത്താഴം',
      permission: 'അനുമതി',
      mgmt_work: 'മാനേജ്‌മെന്റ് ജോലി',
      end_break: 'ബ്രേക്ക് അവസാനിപ്പിക്കുക',
      currently_on: 'ഇപ്പോൾ',
      breaks: 'ബ്രേക്കുകൾ',
      todays_breaks: 'ഇന്നത്തെ ബ്രേക്കുകൾ',
      vehicle_actions: 'വാഹന നടപടികൾ',
      leave_vehicle: 'വാഹനം വിടുക',
      back_to_office: 'ഓഫീസിലേക്ക് മടങ്ങുക',
      move_without_vehicle: 'വാഹനമില്ലാതെ നീങ്ങുക',
      scan_vehicle: 'വാഹന QR സ്കാൻ',
      my_trips: 'എന്റെ ട്രിപ്പുകൾ',
      active: 'ആക്ടീവ്',
      completed: 'പൂർത്തിയായി',
      add_trip: 'ട്രിപ്പ് ചേർക്കുക',
      accept_trip: 'ട്രിപ്പ് സ്വീകരിക്കുക',
      reject_trip: 'നിരസിക്കുക',
      start_trip: 'ട്രിപ്പ് ആരംഭിക്കുക',
      pickup_reached: 'പിക്കപ്പ് എത്തി',
      pickup_done: 'പിക്കപ്പ് കഴിഞ്ഞു',
      drop_reached: 'ഡ്രോപ്പ് എത്തി',
      unloading_done: 'ഇറക്കൽ കഴിഞ്ഞു',
      trip_started: 'ട്രിപ്പ് ആരംഭിച്ചു',
      km_reading: 'KM റീഡിംഗ്',
      pickup_location: 'പിക്കപ്പ് സ്ഥലം',
      drop_location: 'ഡ്രോപ്പ് സ്ഥലം',
      fuel_records: 'ഇന്ധന രേഖകൾ',
      add_fuel: 'ഇന്ധനം ചേർക്കുക',
      fuel_amount: 'ഇന്ധന അളവ് (ലിറ്റർ)',
      fuel_cost: 'ചെലവ്',
      km_meter: 'KM മീറ്റർ',
      pump_reading: 'പമ്പ് റീഡിംഗ്',
      bill: 'ബിൽ',
      save_fuel: 'ഇന്ധനം സേവ് ചെയ്യുക',
      allocated: 'അനുവദിച്ചത്',
      accepted: 'സ്വീകരിച്ചത്',
      in_progress: 'പുരോഗതിയിൽ',
      pending: 'തീരുമാനിക്കാത്തത്',
      take_photo: 'ഫോട്ടോ എടുക്കുക',
      capture: 'ക്യാപ്‌ചർ',
      retake: 'വീണ്ടും എടുക്കുക',
      use_photo: 'ഫോട്ടോ ഉപയോഗിക്കുക',
      gps_location: 'GPS ലൊക്കേഷൻ',
      notifications: 'അറിയിപ്പുകൾ',
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'carloo_lang',
      caches: ['localStorage'],
    }
  });

export default i18n;
